<template>
  <div v-if="$store.state.user.role == 1" class="">
    <PageHeader label="Activities for this client"></PageHeader>
    <div class="mt-6">
      <ActivityList></ActivityList>
    </div>
  </div>
</template>

<script>
  import PageHeader   from '@/shared/components/headers/PageHeader'
  import ActivityList from "./ActivityList"
  
  export default {

    components : {
      PageHeader,
      ActivityList,
    },

    created() {
      this.getClient({
        clientId : this.$route.params.clientId
      }, (client) => {
        this.client = client
      })
    },
  }
</script>